import EditBlogTermsModal from './EditBlogTermsModal';

const EditBlogTopicsModal = ({ modalDetails }) => (
  <EditBlogTermsModal modalDetails={modalDetails} kind="topics" />
);

export default EditBlogTopicsModal;
